import React, { Component } from "react";
import {
  ResidentsActions,
  SuperAdminAction,
  CurrentPermitActions,
} from "../../Actions";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import CustomContentAlert, { findBySearch, tzDate } from "../helper";
import DataTable from "react-data-table-component";
import DatatableHeader from "../DatatableHeader/DatatableHeader";
import { connect } from "react-redux";
import PropertDetails from "../LandingPage/PropertySelection";
import Loader from "../Loader/Loader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import PaginationforData from "../pagination/pagination";
const moment_timezone = require("moment-timezone");

class TicketReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      PropertyId: this.props.PropertyId,
      api_response: true,
      properties: [],
      selectedProperty: "",
      selectedPropertyObj: {},
      pageDropdownDisabled: true,
      all_proparties: [],
      selectedPage: "",
      showPropertyModal: false,
      isModalOpen: false,
      isFormValid: false,
      childselect: false,
      childcheckbox: false,
      ticketReportLots: [],
      currentLOT: [],
      user_type: this.props.user_type,
      showAsyncHead: false,
      selectedOption: "",
      loader: false,
      startDate: "",
      endDate: "",
      currentDate: "",
      month: new Date(),
      year: "",
      findMore: false,
      prevSearch: "",
      prevPage: "",
      prevNorow: "",
      page: 1,
      Norow: 10,
      asc: "false",
      sort_direction: "DESC",
      pageChanged: false,
      timezone: this.props.timezone,
      newTr: [],
      currentTR: [],
      searchValue: "",
      selectedColumn: "lot",
      lot_id: "ANY",
      unit_id: "ANY",
      count: 0,
      property: this.props.property,
    };

    this.customStyles = {
      rows: {
        style: {
          minHeight: "72px", // override the row height
        },
      },
      headCells: {
        style: {
          paddingLeft: "8px", // override the cell padding for head cells
          paddingRight: "8px",
        },
      },
      cells: {
        style: {
          paddingLeft: "8px", // override the cell padding for data cells
          paddingRight: "8px",
        },
      },
    };

    this.columns = [
      // {
      //   name: "IMAGE",
      //   sortable: true,
      //   width: "80px",
      //   cell: (row) => (
      //     <SRLWrapper options={options}>
      //       <img
      //         src={row.plate}
      //         className="img-fluid"
      //         onError={(e) => {
      //           e.target.onerror = null;
      //           e.target.src = BrokenImage;
      //         }}
      //       />
      //     </SRLWrapper>
      //   ),
      //   selector: (row) => row.plate,
      // },
      // {
      //   name: "ID",
      //   sortable: true,
      //   cell: (row) => <div>{row.id}</div>,
      //   selector: (row) => row.id,
      // },
      {
        name: "TIME",
        sortable: true,
        width: "170px",
        // cell: (row) => <div>{row.created_at}</div>,
        cell: (row) => <div>{tzDate(this.state.timezone, row.created_at)}</div>,
        selector: (row) => row.created_at,
      },
      {
        name: "SITE",
        sortable: true,
        cell: (row) => <div>{row.site_name}</div>,
        selector: (row) => row.site_name,
      },
      {
        name: "LOT",
        sortable: true,
        cell: (row) => <div>{row.lot_name}</div>,
        selector: (row) => row.lot_name,
      },
      {
        name: "LANE",
        sortable: true,
        cell: (row) => <div>{row.lane_name}</div>,
        selector: (row) => row.lane_name,
      },
      {
        name: "TICKET NO",
        sortable: true,
        cell: (row) => <div>{row.ticket_no}</div>,
        selector: (row) => row.ticket_no,
      },
      {
        name: "BARCODE NO",
        width: "150px",
        sortable: true,
        cell: (row) => <div>{row.vin}</div>,
        selector: (row) => row.vin,
      },
      {
        name: "LPN",
        sortable: true,
        cell: (row) => <div>{row.lpn}</div>,
        selector: (row) => row.lpn,
      },
      {
        name: "PAID TIME",
        width: "200px",
        sortable: true,
        cell: (row) => <div>{row.created_at}</div>,
        selector: (row) => row.created_at,
      },
      {
        name: "AMOUNT",
        sortable: true,
        cell: (row) => <div>{row.amount}</div>,
        selector: (row) => row.amount,
      },
      {
        name: "METER",
        sortable: true,
        cell: (row) => <div>{row.meter_name}</div>,
        selector: (row) => row.meter_name,
      },
      {
        name: "STATUS",
        sortable: true,
        cell: (row) => <div>{row.status}</div>,
        selector: (row) => row.status,
      },
    ];
  }

  componentDidMount = async () => {
    const {
      PropertyId,
      lot_id,
      unit_id,
      childcheckbox,
      month,
      year,
      currentDate,
      startDate,
      endDate,
      page,
      Norow,
      searchValue,
      selectedColumn,
      sort_direction,
      timezone,
    } = this.state;
    const monthFormet = moment_timezone(month).format("MM/YYYY");
    const pageobj = {
      page,
      Norow,
      searchValue,
      selectedColumn,
      sort_direction,
    };

    this.props.get_all_properties();
    await this.props.LotReportListAPI(PropertyId);

    const current_lot = this.props.currentLOT;
    console.log("current_lot:::::::::::", current_lot);

    this.setState({
      ticketReportLots: current_lot,
    });

    await this.props.fetchResidentList();
    if (this.props.api_response) {
      this.setState({
        residentList_: this.props.residentList,
      });
    }
    await this.props.TicketReportListAPI(
      PropertyId,
      lot_id,
      unit_id,
      childcheckbox,
      monthFormet,
      year,
      currentDate,
      startDate,
      endDate,
      pageobj,
      timezone
    );
    this.setState(
      {
        api_response: this.props?.api_response,
        all_proparties: this.props?.getAllProperties,
      },
      async () => {
        const selectedPropertyObj = this.state.all_proparties.find(
          (item) => item.id === this.state.PropertyId
        );
        const selectedPropertyName = selectedPropertyObj
          ? selectedPropertyObj.site_name
          : "";
        const selectedDomainName = selectedPropertyObj
          ? selectedPropertyObj.domain
          : "";
        await this.props.setDomainHeader(
          selectedPropertyName,
          selectedDomainName
        );
        await this.props.selected_Property(selectedPropertyObj);
        if (selectedPropertyObj) {
          this.setState({
            selectedPropertyObj: {
              label: selectedPropertyObj.site_name,
              value: selectedPropertyObj.id,
            },
            selectedProperty: PropertyId,
            selectedDomainName: selectedPropertyObj.site_name,
          });
        }
      }
    );
  };

  handleSearch = () => {
    this.setState({ loader: true, pageChanged: true }, async () => {
      const {
        PropertyId,
        lot_id,
        unit_id,
        childcheckbox,
        month,
        year,
        currentDate,
        startDate,
        endDate,
        page,
        Norow,
        searchValue,
        selectedColumn,
        sort_direction,
        timezone,
      } = this.state;
      const monthFormet = moment_timezone(month).format("MM/YYYY");

      const pageobj = {
        page,
        Norow,
        searchValue,
        selectedColumn,
        sort_direction,
      };
      await this.props.TicketReportListAPI(
        PropertyId,
        lot_id,
        unit_id,
        childcheckbox,
        monthFormet,
        year,
        currentDate,
        startDate,
        endDate,
        pageobj,
        timezone
      );
      const current_tr = this.props.currentTR;
      console.log("current_tr:::::::::::::::::", current_tr);

      if (current_tr) {
        this.setState({
          newTr: current_tr,
          loader: false,
          api_response: this.props.api_response,
        });
      }
    });
  };

  handleSearchChange = ({ target }) => {
    this.setState({ prevSearch: this.state.searchValue });
    this.setState({ searchValue: target.value }, () => {
      if (!this.state.findMore) {
        this.setState(
          {
            pageChanged: true,
            newTr: findBySearch(
              this.state.searchValue,
              this.props.currentTR,
              this.props.currentTR
            ),
          },
          () => {
            this.setState({
              count: this.state.newTr?.length,
            });
          }
        );
      }
    });
  };

  handlepage = ({ target }) => {
    this.setState({ prevPage: this.state.page, prevNorow: this.state.Norow });
    this.setState(
      {
        [target.name]: target.value,
      },
      async () => {
        switch (target.name) {
          case "page":
            this.setState({ page: target.value }, async () => {
              const {
                Norow,
                page,
                PropertyId,
                lot_id,
                unit_id,
                childcheckbox,
                month,
                year,
                currentDate,
                startDate,
                endDate,
                searchValue,
                selectedColumn,
                sort_direction,
                timezone,
              } = this.state;
              const monthFormet = moment_timezone(month).format("MM/YYYY");
              const pageobj = {
                page,
                Norow,
                searchValue,
                selectedColumn,
                sort_direction,
              };
              this.setState({ loader: true, pageChanged: true }, async () => {
                await this.props.TicketReportListAPI(
                  PropertyId,
                  lot_id,
                  unit_id,
                  childcheckbox,
                  monthFormet,
                  year,
                  currentDate,
                  startDate,
                  endDate,
                  pageobj,
                  timezone
                );
                this.setState({
                  newTr: await this.props.currentTR,
                  api_response: this.props.api_response,
                });
                this.setState({ loader: false });
              });
            });
            break;
          case "Norow":
            this.setState(
              { Norow: target.value, pageChanged: true },
              async () => {
                const {
                  PropertyId,
                  lot_id,
                  unit_id,
                  childcheckbox,
                  month,
                  year,
                  currentDate,
                  startDate,
                  endDate,
                  page,
                  Norow,
                  searchValue,
                  selectedColumn,
                  sort_direction,
                  timezone,
                } = this.state;
                const monthFormet = moment_timezone(month).format("MM/YYYY");

                const pageobj = {
                  page,
                  Norow,
                  searchValue,
                  selectedColumn,
                  sort_direction,
                };
                this.setState({ loader: true }, async () => {
                  await this.props.TicketReportListAPI(
                    PropertyId,
                    lot_id,
                    unit_id,
                    childcheckbox,
                    monthFormet,
                    year,
                    currentDate,
                    startDate,
                    endDate,
                    pageobj,
                    timezone
                  );
                  this.setState({
                    newTr: await this.props.currentTR,
                    api_response: this.props.api_response,
                  });
                  this.setState({ loader: false });
                });
              }
            );
            break;
        }
        if (
          Number(this.state.page) !== Number(this.state.prevPage) ||
          Number(this.state.Norow) !== Number(this.state.prevNorow)
        ) {
          const {
            PropertyId,
            lot_id,
            unit_id,
            startDate,
            childcheckbox,
            month,
            year,
            currentDate,
            endDate,
            page,
            Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            timezone,
          } = this.state;
          const monthFormet = moment_timezone(month).format("MM/YYYY");

          const pageobj = {
            page,
            Norow,
            searchValue,
            selectedColumn,
            sort_direction,
          };
          this.setState({ loader: true, pageChanged: true }, async () => {
            await this.props.TicketReportListAPI(
              PropertyId,
              lot_id,
              unit_id,
              childcheckbox,
              monthFormet,
              year,
              currentDate,
              startDate,
              endDate,
              pageobj,
              timezone
            );
            this.setState({
              newTr: await this.props.currentTR,
              api_response: this.props.api_response,
            });
            this.setState({ loader: false });
          });
        }
      }
    );
  };

  handleRowsPerPage = () => {
    const { Norow, page } = this.state;
    return { Norow, page };
  };

  handlepagenext = async () => {
    const { page, Norow } = this.state;
    const count = await this.props.currentTR?.length;
    const finalPage = Math.ceil(count / Norow);
    if (page + 1 <= finalPage) {
      this.setState({ page: page + 1 }, async () => {
        const {
          PropertyId,
          lot_id,
          unit_id,
          childcheckbox,
          month,
          year,
          currentDate,
          startDate,
          endDate,
          searchValue,
          selectedColumn,
          sort_direction,
          timezone,
        } = this.state;
        const monthFormet = moment_timezone(month).format("MM/YYYY");

        const pageobj = {
          page,
          Norow,
          searchValue,
          selectedColumn,
          sort_direction,
        };
        this.setState({ loader: true }, async () => {
          await this.props.TicketReportListAPI(
            PropertyId,
            lot_id,
            unit_id,
            childcheckbox,
            monthFormet,
            year,
            currentDate,
            startDate,
            endDate,
            pageobj,
            timezone
          );
          this.setState({
            newTr: await this.props.currentTR,
            api_response: this.props.api_response,
          });
          this.setState({ loader: false });
        });
      });
    }
  };

  handlepageprevious = () => {
    const { page } = this.state;
    if (page !== 1) {
      this.setState({ page: page - 1 }, async () => {
        const {
          PropertyId,
          lot_id,
          unit_id,
          childcheckbox,
          month,
          year,
          currentDate,
          startDate,
          endDate,
          Norow,
          searchValue,
          selectedColumn,
          sort_direction,
          timezone,
        } = this.state;
        const monthFormet = moment_timezone(month).format("MM/YYYY");

        const pageobj = {
          page,
          Norow,
          searchValue,
          selectedColumn,
          sort_direction,
        };
        this.setState({ loader: true }, async () => {
          await this.props.TicketReportListAPI(
            PropertyId,
            lot_id,
            unit_id,
            childcheckbox,
            monthFormet,
            year,
            currentDate,
            startDate,
            endDate,
            pageobj,
            timezone
          );
          this.setState({
            newTr: await this.props.currentTR,
            api_response: this.props.api_response,
          });
          this.setState({ loader: false });
        });
      });
    }
  };

  handlepageinitial = () => {
    if (this.state.page !== 1) {
      this.setState({ page: 1 }, async () => {
        const {
          PropertyId,
          lot_id,
          unit_id,
          childcheckbox,
          month,
          year,
          currentDate,
          startDate,
          endDate,
          page,
          Norow,
          searchValue,
          selectedColumn,
          sort_direction,
          timezone,
        } = this.state;
        const monthFormet = moment_timezone(month).format("MM/YYYY");

        const pageobj = {
          page,
          Norow,
          searchValue,
          selectedColumn,
          sort_direction,
        };
        this.setState({ loader: true }, async () => {
          await this.props.TicketReportListAPI(
            PropertyId,
            lot_id,
            unit_id,
            childcheckbox,
            monthFormet,
            year,
            currentDate,
            startDate,
            endDate,
            pageobj,
            timezone
          );
          this.setState({
            newTr: await this.props.currentTR,
            api_response: this.props.api_response,
          });
          this.setState({ loader: false });
        });
      });
    }
  };

  handlepagefinal = async () => {
    const { page, Norow } = this.state;
    const count = await this.props.currentTR?.length;
    this.setState({
      count: count,
    });
    const last_page = count / Norow;
    const rounded = Math.round(last_page);
    if (page < rounded) {
      this.setState({ page: rounded }, async () => {
        const {
          PropertyId,
          lot_id,
          unit_id,
          childcheckbox,
          month,
          year,
          currentDate,
          startDate,
          endDate,
          searchValue,
          selectedColumn,
          sort_direction,
          timezone,
        } = this.state;
        const monthFormet = moment_timezone(month).format("MM/YYYY");

        const pageobj = {
          page,
          Norow,
          searchValue,
          selectedColumn,
          sort_direction,
        };
        this.setState({ loader: true }, async () => {
          await this.props.TicketReportListAPI(
            PropertyId,
            lot_id,
            unit_id,
            childcheckbox,
            monthFormet,
            year,
            currentDate,
            startDate,
            endDate,
            pageobj,
            timezone
          );
          this.setState({
            newTr: await this.props.currentTR,
            api_response: this.props.api_response,
          });
          this.setState({ loader: false });
        });
      });
    }
  };

  changeProperty(event) {
    this.setState(
      { selectedProperty: event.value, selectedPropertyObj: event },
      () => {
        const selectedPropertyObj = this.state.all_proparties.find(
          (item) => item.id === this.state.selectedProperty
        );

        this.props.selected_Property(selectedPropertyObj);
        this.setState({
          isFormValid: true,
          pageDropdownDisabled: false,
        });
      }
    );
  }

  handleChange = ({ target }) => {
    this.setState({ [target.name]: target.value });
  };

  handleCheckBox = (e) => {
    console.log("event::::::::", e.target.checked);
    this.setState({ childcheckbox: !this.state.childcheckbox });
  };

  handleUpdateChange = (e) => {
    const selected = e.target.value;
    this.setState({ selectedOption: selected });
  };

  handleCurrentDate = (date) => {
    this.setState({
      currentDate: date,
      month: null,
      year: null,
      startDate: null,
      endDate: null,
    });
  };

  handleChangeStartingDates = (date) => {
    console.log(date);
    this.setState({
      startDate: date,
      month: null,
      year: null,
      currentDate: null,
      endDate: new Date(),
    });
  };

  handleChangeEndDates = (date) => {
    console.log(date);
    this.setState({
      endDate: date,
      month: null,
      year: null,
      currentDate: null,
    });
  };

  handleMonth = (date) => {
    console.log(date);
    this.setState({
      month: date,
      startDate: null,
      endDate: null,
      year: null,
      currentDate: null,
    });
  };

  handleYear = (date) => {
    console.log(date);
    this.setState({
      year: date,
      month: null,
      startDate: null,
      endDate: null,
      currentDate: null,
    });
  };

  render() {
    const {
      ticketReportLots,
      residentList_,
      // selectedOption,
      loader,
      startDate,
      endDate,
      currentDate,
      month,
      year,
      api_response,
      page,
      Norow,
      searchValue,
      pageChanged,
      newTr,
      lot_id,
      unit_id,
      childcheckbox,
      currentTR,
    } = this.state;
    return (
      <>
        <Container fluid>
          <Row className="">
            <Col md="12">
              <Card className="contact-container mb-0">
                {/*  <Card.Header>
                  <div>
                    <div>
                      <Card.Title as="h4" className="my-1">
                        Citation Report
                      </Card.Title>
                    </div>
                  </div>
                </Card.Header> */}
                <Card.Body className="pos-rel-overflow-hide">
                  <Container fluid={true}>
                    {/* <h5>Select Property</h5> */}
                    <Row>
                      <Col sm={12} md={3}>
                        <PropertDetails
                          selectedPropertyObj={this.state.selectedPropertyObj}
                          changeProperty={this.changeProperty.bind(this)}
                        />
                      </Col>
                      <Col sm={12} md={3} className="mt-sm-4 ">
                        <label className="fancy-checkbox mt-2">
                          <input
                            type="checkbox"
                            name={"childcheckbox"}
                            checked={childcheckbox}
                            onChange={this.handleCheckBox}
                            className="custom-control-input"
                            id="childcheckbox1"
                          ></input>
                          <span>
                            <i></i>Include Children Sites
                          </span>
                        </label>
                      </Col>
                      <Col sm={6} md={3}>
                        <Form.Group controlId="exampleForm.ControlSelect1">
                          <Form.Label>LOTS:</Form.Label>
                          <Form.Control
                            as="select"
                            name="lot_id"
                            disabled={loader}
                            value={lot_id}
                            onChange={this.handleChange}
                          >
                            {ticketReportLots && ticketReportLots.length ? (
                              <>
                                <option value="ANY">ANY</option>
                                {ticketReportLots.map((item, index) => (
                                  <option key={index} value={item.lot_id}>
                                    {item.alias}
                                  </option>
                                ))}
                              </>
                            ) : null}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={6} md={3}>
                        <Form.Group controlId="exampleForm.ControlSelect1">
                          <Form.Label>UNITS:</Form.Label>
                          <Form.Control
                            as="select"
                            name="unit_id"
                            // disabled={loader}
                            value={unit_id}
                            onChange={this.handleChange}
                          >
                            {residentList_ && residentList_.length ? (
                              <>
                                <option value="ANY">ANY</option>

                                {residentList_.map((item, index) => (
                                  <option key={index} value={item.id}>
                                    {item.suite_id}
                                  </option>
                                ))}
                              </>
                            ) : null}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6} md={2}>
                        <Form.Group>
                          <label className="mb-0 mr-2">MONTH:</label>
                          <DatePicker
                            placeholder="02/2022"
                            className="form-control"
                            selected={month}
                            defaultHour={24}
                            value={new Date()}
                            disabled={loader}
                            onChange={this.handleMonth}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                          />
                        </Form.Group>
                      </Col>
                      <Col sm={6} lg={2}>
                        <Form.Group>
                          <label className="mb-0 mr-2">YEAR:</label>
                          <DatePicker
                            // maxDate={new Date()}
                            placeholder="2022"
                            className="form-control"
                            selected={year}
                            defaultHour={24}
                            value={new Date()}
                            disabled={loader}
                            onChange={this.handleYear}
                            showYearPicker
                            dateFormat="yyyy"
                          />
                        </Form.Group>
                      </Col>
                      <Col sm={6} lg={2}>
                        <Form.Group>
                          <label className="mb-0 mr-2">DATE:</label>
                          <DatePicker
                            // maxDate={new Date()}
                            placeholder="04/04/16"
                            className="form-control"
                            selected={currentDate}
                            defaultHour={24}
                            value={new Date()}
                            disabled={loader}
                            onChange={this.handleCurrentDate}
                            dateFormat="d/MM/yyyy"
                          />
                        </Form.Group>
                      </Col>
                      <Col sm={6} lg={3}>
                        <Form.Group>
                          <label className="mb-0 mr-2">START DATE:</label>
                          <DatePicker
                            // maxDate={new Date()}
                            // // clearIcon={<i className="fas fa-times" onClick={() => this.setState({ start_date: "" })}></i>}
                            // placeholder="04/04/16"
                            selected={startDate}
                            className="form-control"
                            defaultHour={24}
                            value={new Date()}
                            disabled={loader}
                            selectsStart
                            timeInputLabel="Time:"
                            onChange={this.handleChangeStartingDates}
                            dateFormat="MM/dd/yyyy"
                            startDate={startDate}
                            endDate={endDate}
                          />
                        </Form.Group>
                      </Col>
                      <Col sm={6} lg={3}>
                        <Form.Group>
                          <label className="mb-0 mr-2">END DATE:</label>
                          <DatePicker
                            selected={endDate}
                            placeholder="04/04/16"
                            disabled={loader}
                            className="form-control"
                            value={new Date()}
                            selectsEnd
                            timeInputLabel="Time:"
                            onChange={this.handleChangeEndDates}
                            dateFormat="MM/dd/yyyy"
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group className="ml-3 mt-2"></Form.Group>
                      </Col>
                      <div className="col-auto">
                        <Button
                          variant="info"
                          className="h-40 btn-fill"
                          onClick={this.handleSearch}
                          disabled={loader}
                        >
                          Search
                        </Button>
                      </div>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {loader ? (
            <Loader />
          ) : (
            <>
              {!api_response ? (
                <CustomContentAlert
                  delay={4000}
                  message={
                    "The server did not respond, Please try again after sometime"
                  }
                  className="toast-error"
                />
              ) : null}
              <Card className="mt-2">
                <Card.Body>
                  {!newTr?.length ? (
                    <span className="text-center d-block">{`There are no records to display`}</span>
                  ) : null}
                  {newTr && newTr?.length ? (
                    <>
                      <div className="report-citation-box">
                        <DataTable
                          data={
                            searchValue.length || pageChanged
                              ? newTr
                              : currentTR
                          }
                          columns={this.columns}
                          customStyles={this.customStyles}
                          // pagination={true}
                          responsive={true}
                          subHeader
                          subHeaderComponent={
                            <>
                              <DatatableHeader
                                Header={"Citation Report"}
                                searchValue={searchValue}
                                HandleChange={this.handleSearchChange}
                                findMorePressed={this.findMorePressed}
                              />
                              {/* <Button onClick={this.findMorePressed}>
                            Get All Result for {searchValue}
                          </Button> */}
                            </>
                          }
                          defaultSortAsc={false}
                          fixedHeader={true}
                          fixedHeaderScrollHeight="40vh"
                        />
                      </div>
                      <PaginationforData
                        count={this.state.count}
                        data={this.props.currentTR}
                        handlepageinitial={this.handlepageinitial}
                        handlepageprevious={this.handlepageprevious}
                        handlepagenext={this.handlepagenext}
                        handlepagefinal={this.handlepagefinal}
                        handlepage={this.handlepage}
                        page={page}
                        Norow={Norow}
                      />
                    </>
                  ) : null}
                </Card.Body>
              </Card>
            </>
          )}
        </Container>
      </>
    );
  }
}

const mapStatetoProps = ({
  SuperAdminDetails,
  ResidenDetails,
  UserProfileDetails,
  CurrentPermitDetails,
  APIResponseDetails,
}) => {
  const { api_response, api_error_message, api_success_message } =
    APIResponseDetails;
  const { getAllProperties } = SuperAdminDetails;
  const { currentLOT, currentTR } = ResidenDetails;
  const { residentList } = CurrentPermitDetails;
  const {
    property_id: PropertyId,
    user_type,
    timezone,
    property,
  } = UserProfileDetails;

  return {
    getAllProperties,
    currentLOT,
    PropertyId,
    user_type,
    residentList,
    api_response,
    api_error_message,
    api_success_message,
    timezone,
    currentTR,
    property,
  };
};

const mapStateToDispatch = {
  fetchResidentList: CurrentPermitActions.fetchResidentList,
  LotReportListAPI: ResidentsActions.LotReportListAPI,
  TicketReportListAPI: ResidentsActions.TicketReportListAPI,
  get_all_properties: SuperAdminAction.get_all_properties,
  selected_Property: SuperAdminAction.selected_Property,
  setDomainHeader: SuperAdminAction.setDomainHeader,
};

export default connect(mapStatetoProps, mapStateToDispatch)(TicketReport);
